import React, { useState, ReactNode } from 'react';
import { Box, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export interface SearchableListProps<T> {
  items: T[];
  getLabel: (item: T) => string;
  placeholder?: string;
  children: (item: T) => ReactNode;
  listSx?: any;
  listRef?: React.Ref<HTMLDivElement>;
}

export default function SearchableList<T>({ items, getLabel, placeholder = 'Buscar...', children, listSx, listRef }: SearchableListProps<T>) {
  const [searchTerm, setSearchTerm] = useState('');
  const term = (searchTerm || '').trim().toLowerCase();
  const filtered = term ? items.filter(i => (getLabel(i) || '').toLowerCase().includes(term)) : items;

  return (
    <Box>
      <Box mb={2}>
        <TextField
          size="small"
          fullWidth
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
            'aria-label': 'Buscar itens'
          }}
        />
      </Box>

      <Box ref={listRef} sx={listSx}>
        {filtered.map((item: T, idx) => (
          <Box key={idx} mb={1}>
            {children(item)}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
